import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalBody,
	ModalCloseButton,
	Text,
	Box,
	useClipboard,
	useToast,
	Image,
} from '@chakra-ui/react';
import { CopyIcon } from '@chakra-ui/icons';
import { useEffect } from 'react';

import donateQRCode from '../../assets/images/png/donation_qrcode3.png';
import './styles.css';

const QRCodeModal = ({ isOpen, onClose, walletAddress }) => {
	const { hasCopied, onCopy } = useClipboard(walletAddress);
	const toast = useToast();

	useEffect(() => {
		if (hasCopied !== false) {
			toast({
				title: hasCopied ? "Copied!" : "Failed to copy.",
				status: hasCopied ? "success" : "error",
				duration: 2000,
				isClosable: true,
			});
		}
	}, [hasCopied, toast]);

	return (
		<Modal isOpen={isOpen} onClose={onClose} size={{ base: "sm", md: "md" }}>
			<ModalOverlay />
			<ModalContent p={4} mx={{ base: 2, md: 4 }} my={{ base: 4, md: 8 }}>
				<ModalHeader fontSize={{ base: "md", md: "lg" }} textAlign="center" color="black">
					Support us with an ERC20 donation!
				</ModalHeader>
				<ModalCloseButton />
				<ModalBody textAlign="center" p={6}>
					<Box mb={4} display="flex" justifyContent="center">
						<Image className="heartbeat" src={donateQRCode} alt="Donation QR Code" maxW={{ base: "90%", md: "70%" }} />
					</Box>
					<Box pt={4} mb={4} display="flex" alignItems="center" justifyContent="center">
						<Text fontSize={{ base: "md", md: "lg" }} mr={2}>{walletAddress}</Text>
						<CopyIcon
							onClick={onCopy}
							colorScheme="teal"
							size="sm"
							cursor="pointer"
							color="#ff684b"
						/>
					</Box>
				</ModalBody>
			</ModalContent>
		</Modal>
	);
};

export default QRCodeModal;
